import { Event, useStore } from '@mirai/data-sources';
import { useEffect } from 'react';

import { EVENT } from './EventManager.constants';
import { EVENT as COMPONENTS_EVENT } from '../../components/helpers';
import { configureErrorTracking } from '../../helpers/trackError';

const EventManager = () => {
  const { value = {}, set } = useStore();
  const { cookieBanner: { countryInactive } = {}, finder = {}, hotel, id, session, tags = {}, type } = value;

  useEffect(() => {
    configureErrorTracking({ hotel, id, session, type });
  }, [hotel, id, session, type]);

  useEffect(() => {
    const handleSetStore = ({
      chainSelectorValue: placeId,
      calendar,
      currency,
      hsri: commissionCode,
      locale,
      occupation,
      promocode,
    } = {}) => {
      const next = {};

      if (commissionCode) next.origin = { commissionCode };
      if (calendar?.length && calendar?.length === 2) next.finder = { calendar };
      if (currency) next.currency = currency;
      if (locale) {
        const [language] = locale.split('-');
        next.language = language;
        next.locale = locale;
        Event.publish(COMPONENTS_EVENT.LOCALE_CHANGED, { locale, language });
      }
      if (occupation?.length) next.finder = { ...next.finder, occupation };
      if (promocode !== undefined && promocode !== null) next.finder = { ...next.finder, promocode };
      if (placeId) next.finder = { ...next.finder, place: tags?.options?.find(({ value } = {}) => value === placeId) };

      set(next);
    };

    Event.subscribe(EVENT.SET_STORE, handleSetStore);

    return () => Event.unsubscribe(EVENT.SET_STORE, handleSetStore);
  }, [set, tags]);

  useEffect(() => {
    if (!finder) return;

    Event.subscribe(COMPONENTS_EVENT.FINDER_FIELD_CHANGE, handleFinderFieldChange);

    Event.publish(EVENT.FINDER_LOADED, finder);

    return () => Event.unsubscribe(COMPONENTS_EVENT.FINDER_FIELD_CHANGE, handleFinderFieldChange);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!countryInactive) return;

    Event.publish(EVENT.COOKIE_BANNER_SKIPPED_BY_COUNTRY);
  }, [countryInactive]);

  const handleFinderFieldChange = (value) => Event.publish(EVENT.FINDER_CHANGE, value);

  return null;
};

export { EventManager };
